import amounts from '../data/insuranceAmounts'
import periods from '../data/paymentPeriods'
import methods from '../data/paymentMethods'
import insurancePeriods from '../data/insurancePeriods'
import candidateInsureds from '../data/candidateInsureds'
import sexs from '../data/sexs'
import getAgeFromBirthday from '../utils/getAgeFromBirthday'
import getAgeAndSexFromID from '../utils/getAgeAndSexFromID'
import cities from '../data/cities'
import bankCodes from '../data/bankCodes'

import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default {
  /**
   * 保障额度
   * 根据投保人出生日期计算
   * @param {*} state
   */
  insuranceAmountsByBirthday (state, getters) {
    let age = getters.ageFromBirthday
    if (age >= 18 && age <= 40 && state.holder.area[1]) {
      if (cities.super.indexOf(state.holder.area[1]) !== -1) {
        return [
          {
            name: '30万',
            value: '3',
            accessable: true
          },
          {
            name: '50万',
            value: '5',
            accessable: true
          },
          {
            name: '100万',
            value: '10',
            accessable: true
          },
          {
            name: '150万',
            value: '15',
            accessable: true
          }
        ]
      } else if (cities.first.indexOf(state.holder.area[1]) !== -1) {
        return [
          {
            name: '30万',
            value: '3',
            accessable: true
          },
          {
            name: '50万',
            value: '5',
            accessable: true
          },
          {
            name: '100万',
            value: '10',
            accessable: true
          },
          {
            name: '150万',
            value: '15',
            accessable: false
          }
        ]
      } else {
        return [
          {
            name: '30万',
            value: '3',
            accessable: true
          },
          {
            name: '50万',
            value: '5',
            accessable: true
          },
          {
            name: '100万',
            value: '10',
            accessable: false
          },
          {
            name: '150万',
            value: '15',
            accessable: false
          }
        ]
      }
    } else if (age >= 41 && age <= 50 && state.holder.area[1]) {
      if (cities.super.indexOf(state.holder.area[1]) !== -1) {
        return [
          {
            name: '30万',
            value: '3',
            accessable: true
          },
          {
            name: '50万',
            value: '5',
            accessable: true
          },
          {
            name: '100万',
            value: '10',
            accessable: true
          },
          {
            name: '150万',
            value: '15',
            accessable: false
          }
        ]
      } else if (cities.first.indexOf(state.holder.area[1]) !== -1) {
        return [
          {
            name: '30万',
            value: '3',
            accessable: true
          },
          {
            name: '50万',
            value: '5',
            accessable: true
          },
          {
            name: '100万',
            value: '10',
            accessable: false
          },
          {
            name: '150万',
            value: '15',
            accessable: false
          }
        ]
      } else {
        return [
          {
            name: '30万',
            value: '3',
            accessable: true
          },
          {
            name: '50万',
            value: '5',
            accessable: true
          },
          {
            name: '100万',
            value: '10',
            accessable: false
          },
          {
            name: '150万',
            value: '15',
            accessable: false
          }
        ]
      }
    } else if (age >= 41 && age <= 50 && state.holder.area.length === 0) {
      return [
        {
          name: '30万',
          value: '3',
          accessable: true
        },
        {
          name: '50万',
          value: '5',
          accessable: true
        },
        {
          name: '100万',
          value: '10',
          accessable: true
        },
        {
          name: '150万',
          value: '15',
          accessable: false
        }
      ]
    } else if (age >= 51 && age <= 60 && state.holder.area[1]) {
      if (cities.super.indexOf(state.holder.area[1]) !== -1) {
        return [
          {
            name: '30万',
            value: '3',
            accessable: true
          },
          {
            name: '50万',
            value: '5',
            accessable: true
          },
          {
            name: '100万',
            value: '10',
            accessable: false
          },
          {
            name: '150万',
            value: '15',
            accessable: false
          }
        ]
      } else if (cities.first.indexOf(state.holder.area[1]) !== -1) {
        return [
          {
            name: '30万',
            value: '3',
            accessable: true
          },
          {
            name: '50万',
            value: '5',
            accessable: true
          },
          {
            name: '100万',
            value: '10',
            accessable: false
          },
          {
            name: '150万',
            value: '15',
            accessable: false
          }
        ]
      } else {
        return [
          {
            name: '30万',
            value: '3',
            accessable: true
          },
          {
            name: '50万',
            value: '5',
            accessable: false
          },
          {
            name: '100万',
            value: '10',
            accessable: false
          },
          {
            name: '150万',
            value: '15',
            accessable: false
          }
        ]
      }
    } else if (age >= 51 && age <= 60 && state.holder.area.length === 0) {
      return [
        {
          name: '30万',
          value: '3',
          accessable: true
        },
        {
          name: '50万',
          value: '5',
          accessable: true
        },
        {
          name: '100万',
          value: '10',
          accessable: false
        },
        {
          name: '150万',
          value: '15',
          accessable: false
        }
      ]
    } else if (age === null && state.holder.area[1]) {
      if (cities.super.indexOf(state.holder.area[1]) !== -1) {
        return [
          {
            name: '30万',
            value: '3',
            accessable: true
          },
          {
            name: '50万',
            value: '5',
            accessable: true
          },
          {
            name: '100万',
            value: '10',
            accessable: true
          },
          {
            name: '150万',
            value: '15',
            accessable: true
          }
        ]
      } else if (cities.first.indexOf(state.holder.area[1]) !== -1) {
        return [
          {
            name: '30万',
            value: '3',
            accessable: true
          },
          {
            name: '50万',
            value: '5',
            accessable: true
          },
          {
            name: '100万',
            value: '10',
            accessable: true
          },
          {
            name: '150万',
            value: '15',
            accessable: false
          }
        ]
      } else {
        return [
          {
            name: '30万',
            value: '3',
            accessable: true
          },
          {
            name: '50万',
            value: '5',
            accessable: true
          },
          {
            name: '100万',
            value: '10',
            accessable: false
          },
          {
            name: '150万',
            value: '15',
            accessable: false
          }
        ]
      }
    }
    return amounts.map(function (ele) {
      ele.accessable = true
      return ele
    })
  },

  /**
   * 保障额度
   * 根据投保人身份证计算
   * @param {*} state
   */
  insuranceAmountsByIDNumber (state, getters) {
    let age = getters.ageFromIDNumber
    if (age >= 18 && age <= 40 && state.holder.area[1]) {
      if (cities.super.indexOf(state.holder.area[1]) !== -1) {
        return [
          {
            name: '30万',
            value: '3',
            accessable: true
          },
          {
            name: '50万',
            value: '5',
            accessable: true
          },
          {
            name: '100万',
            value: '10',
            accessable: true
          },
          {
            name: '150万',
            value: '15',
            accessable: true
          }
        ]
      } else if (cities.first.indexOf(state.holder.area[1]) !== -1) {
        return [
          {
            name: '30万',
            value: '3',
            accessable: true
          },
          {
            name: '50万',
            value: '5',
            accessable: true
          },
          {
            name: '100万',
            value: '10',
            accessable: true
          },
          {
            name: '150万',
            value: '15',
            accessable: false
          }
        ]
      } else {
        return [
          {
            name: '30万',
            value: '3',
            accessable: true
          },
          {
            name: '50万',
            value: '5',
            accessable: true
          },
          {
            name: '100万',
            value: '10',
            accessable: false
          },
          {
            name: '150万',
            value: '15',
            accessable: false
          }
        ]
      }
    } else if (age >= 41 && age <= 50 && state.holder.area[1]) {
      if (cities.super.indexOf(state.holder.area[1]) !== -1) {
        return [
          {
            name: '30万',
            value: '3',
            accessable: true
          },
          {
            name: '50万',
            value: '5',
            accessable: true
          },
          {
            name: '100万',
            value: '10',
            accessable: true
          },
          {
            name: '150万',
            value: '15',
            accessable: false
          }
        ]
      } else if (cities.first.indexOf(state.holder.area[1]) !== -1) {
        return [
          {
            name: '30万',
            value: '3',
            accessable: true
          },
          {
            name: '50万',
            value: '5',
            accessable: true
          },
          {
            name: '100万',
            value: '10',
            accessable: false
          },
          {
            name: '150万',
            value: '15',
            accessable: false
          }
        ]
      } else {
        return [
          {
            name: '30万',
            value: '3',
            accessable: true
          },
          {
            name: '50万',
            value: '5',
            accessable: true
          },
          {
            name: '100万',
            value: '10',
            accessable: false
          },
          {
            name: '150万',
            value: '15',
            accessable: false
          }
        ]
      }
    } else if (age >= 41 && age <= 50 && state.holder.area.length === 0) {
      return [
        {
          name: '30万',
          value: '3',
          accessable: true
        },
        {
          name: '50万',
          value: '5',
          accessable: true
        },
        {
          name: '100万',
          value: '10',
          accessable: true
        },
        {
          name: '150万',
          value: '15',
          accessable: false
        }
      ]
    } else if (age >= 51 && age <= 60 && state.holder.area[1]) {
      if (cities.super.indexOf(state.holder.area[1]) !== -1) {
        return [
          {
            name: '30万',
            value: '3',
            accessable: true
          },
          {
            name: '50万',
            value: '5',
            accessable: true
          },
          {
            name: '100万',
            value: '10',
            accessable: false
          },
          {
            name: '150万',
            value: '15',
            accessable: false
          }
        ]
      } else if (cities.first.indexOf(state.holder.area[1]) !== -1) {
        return [
          {
            name: '30万',
            value: '3',
            accessable: true
          },
          {
            name: '50万',
            value: '5',
            accessable: true
          },
          {
            name: '100万',
            value: '10',
            accessable: false
          },
          {
            name: '150万',
            value: '15',
            accessable: false
          }
        ]
      } else {
        return [
          {
            name: '30万',
            value: '3',
            accessable: true
          },
          {
            name: '50万',
            value: '5',
            accessable: false
          },
          {
            name: '100万',
            value: '10',
            accessable: false
          },
          {
            name: '150万',
            value: '15',
            accessable: false
          }
        ]
      }
    } else if (age >= 51 && age <= 60 && state.holder.area.length === 0) {
      return [
        {
          name: '30万',
          value: '3',
          accessable: true
        },
        {
          name: '50万',
          value: '5',
          accessable: true
        },
        {
          name: '100万',
          value: '10',
          accessable: false
        },
        {
          name: '150万',
          value: '15',
          accessable: false
        }
      ]
    } else if (age === null && state.holder.area[1]) {
      if (cities.super.indexOf(state.holder.area[1]) !== -1) {
        return [
          {
            name: '30万',
            value: '3',
            accessable: true
          },
          {
            name: '50万',
            value: '5',
            accessable: true
          },
          {
            name: '100万',
            value: '10',
            accessable: true
          },
          {
            name: '150万',
            value: '15',
            accessable: true
          }
        ]
      } else if (cities.first.indexOf(state.holder.area[1]) !== -1) {
        return [
          {
            name: '30万',
            value: '3',
            accessable: true
          },
          {
            name: '50万',
            value: '5',
            accessable: true
          },
          {
            name: '100万',
            value: '10',
            accessable: true
          },
          {
            name: '150万',
            value: '15',
            accessable: false
          }
        ]
      } else {
        return [
          {
            name: '30万',
            value: '3',
            accessable: true
          },
          {
            name: '50万',
            value: '5',
            accessable: true
          },
          {
            name: '100万',
            value: '10',
            accessable: false
          },
          {
            name: '150万',
            value: '15',
            accessable: false
          }
        ]
      }
    }
    return amounts.map(function (ele) {
      ele.accessable = true
      return ele
    })
  },

  /**
   * 交费期间
   * 根据投保人出生日期计算
   * @param {*} state
   */
  paymentPeriodsByBirthday (state, getters) {
    let age = getters.ageFromBirthday
    if ((age >= 41 && age <= 50 && state.order.insurancePeriod === '60') ||
      (age >= 46 && age <= 55 && state.order.insurancePeriod === '65') ||
      (age >= 51 && age <= 60 && state.order.insurancePeriod === '70')) {
      return [
        {
          name: '5年',
          value: '5',
          accessable: true
        },
        {
          name: '10年',
          value: '10',
          accessable: true
        },
        {
          name: '20年',
          value: '20',
          accessable: false
        }
      ]
    }
    return periods.map(function (ele) {
      ele.accessable = true
      return ele
    })
  },

  /**
   * 交费期间
   * 根据投保人身份证计算
   * @param {*} state
   */
  paymentPeriodsByIDNumber (state, getters) {
    let age = getters.ageFromIDNumber
    if ((age >= 41 && age <= 50 && state.order.insurancePeriod === '60') ||
      (age >= 46 && age <= 55 && state.order.insurancePeriod === '65') ||
      (age >= 51 && age <= 60 && state.order.insurancePeriod === '70')) {
      return [
        {
          name: '5年',
          value: '5',
          accessable: true
        },
        {
          name: '10年',
          value: '10',
          accessable: true
        },
        {
          name: '20年',
          value: '20',
          accessable: false
        }
      ]
    }
    return periods.map(function (ele) {
      ele.accessable = true
      return ele
    })
  },

  /**
   * 根据出生日期计算可用的保险期间
   * @param {*} state
   */
  accessableInsurancePeriodsByBitthday (state, getters) {
    let age = getters.ageFromBirthday
    if (age >= 41 && age <= 45) {
      if (state.order.paymentPeriod === '20') {
        return [
          {
            name: '20年期',
            value: '20',
            accessable: true
          },
          {
            name: '30年期',
            value: '30',
            accessable: false
          },
          {
            name: '至60周岁',
            value: '60',
            accessable: false
          },
          {
            name: '至65周岁',
            value: '65',
            accessable: true
          },
          {
            name: '至70周岁',
            value: '70',
            accessable: true
          }
        ]
      } else {
        return [
          {
            name: '20年期',
            value: '20',
            accessable: true
          },
          {
            name: '30年期',
            value: '30',
            accessable: false
          },
          {
            name: '至60周岁',
            value: '60',
            accessable: true
          },
          {
            name: '至65周岁',
            value: '65',
            accessable: true
          },
          {
            name: '至70周岁',
            value: '70',
            accessable: true
          }
        ]
      }
    } else if (age >= 46 && age <= 50) {
      if (state.order.paymentPeriod === '20') {
        return [
          {
            name: '20年期',
            value: '20',
            accessable: true
          },
          {
            name: '30年期',
            value: '30',
            accessable: false
          },
          {
            name: '至60周岁',
            value: '60',
            accessable: false
          },
          {
            name: '至65周岁',
            value: '65',
            accessable: false
          },
          {
            name: '至70周岁',
            value: '70',
            accessable: true
          }
        ]
      } else {
        return [
          {
            name: '20年期',
            value: '20',
            accessable: true
          },
          {
            name: '30年期',
            value: '30',
            accessable: false
          },
          {
            name: '至60周岁',
            value: '60',
            accessable: true
          },
          {
            name: '至65周岁',
            value: '65',
            accessable: true
          },
          {
            name: '至70周岁',
            value: '70',
            accessable: true
          }
        ]
      }
    } else if (age >= 51 && age <= 55) {
      return [
        {
          name: '20年期',
          value: '20',
          accessable: false
        },
        {
          name: '30年期',
          value: '30',
          accessable: false
        },
        {
          name: '至60周岁',
          value: '60',
          accessable: false
        },
        {
          name: '至65周岁',
          value: '65',
          accessable: true
        },
        {
          name: '至70周岁',
          value: '70',
          accessable: true
        }
      ]
    } else if (age >= 56 && age <= 60) {
      return [
        {
          name: '20年期',
          value: '20',
          accessable: false
        },
        {
          name: '30年期',
          value: '30',
          accessable: false
        },
        {
          name: '至60周岁',
          value: '60',
          accessable: false
        },
        {
          name: '至65周岁',
          value: '65',
          accessable: false
        },
        {
          name: '至70周岁',
          value: '70',
          accessable: true
        }
      ]
    }
    return insurancePeriods.map((ele) => {
      ele.accessable = true
      return ele
    })
  },

  /**
   * 根据身份证计算可用的保险期间
   * @param {*} state
   */
  accessableInsurancePeriodsByIDNumber (state, getters) {
    let age = getters.ageFromIDNumber
    if (age >= 41 && age <= 45) {
      if (state.order.paymentPeriod === '20') {
        return [
          {
            name: '20年期',
            value: '20',
            accessable: true
          },
          {
            name: '30年期',
            value: '30',
            accessable: false
          },
          {
            name: '至60周岁',
            value: '60',
            accessable: false
          },
          {
            name: '至65周岁',
            value: '65',
            accessable: true
          },
          {
            name: '至70周岁',
            value: '70',
            accessable: true
          }
        ]
      } else {
        return [
          {
            name: '20年期',
            value: '20',
            accessable: true
          },
          {
            name: '30年期',
            value: '30',
            accessable: false
          },
          {
            name: '至60周岁',
            value: '60',
            accessable: true
          },
          {
            name: '至65周岁',
            value: '65',
            accessable: true
          },
          {
            name: '至70周岁',
            value: '70',
            accessable: true
          }
        ]
      }
    } else if (age >= 46 && age <= 50) {
      if (state.order.paymentPeriod === '20') {
        return [
          {
            name: '20年期',
            value: '20',
            accessable: true
          },
          {
            name: '30年期',
            value: '30',
            accessable: false
          },
          {
            name: '至60周岁',
            value: '60',
            accessable: false
          },
          {
            name: '至65周岁',
            value: '65',
            accessable: false
          },
          {
            name: '至70周岁',
            value: '70',
            accessable: true
          }
        ]
      } else {
        return [
          {
            name: '20年期',
            value: '20',
            accessable: true
          },
          {
            name: '30年期',
            value: '30',
            accessable: false
          },
          {
            name: '至60周岁',
            value: '60',
            accessable: true
          },
          {
            name: '至65周岁',
            value: '65',
            accessable: true
          },
          {
            name: '至70周岁',
            value: '70',
            accessable: true
          }
        ]
      }
    } else if (age >= 51 && age <= 55) {
      return [
        {
          name: '20年期',
          value: '20',
          accessable: false
        },
        {
          name: '30年期',
          value: '30',
          accessable: false
        },
        {
          name: '至60周岁',
          value: '60',
          accessable: false
        },
        {
          name: '至65周岁',
          value: '65',
          accessable: true
        },
        {
          name: '至70周岁',
          value: '70',
          accessable: true
        }
      ]
    } else if (age >= 56 && age <= 60) {
      return [
        {
          name: '20年期',
          value: '20',
          accessable: false
        },
        {
          name: '30年期',
          value: '30',
          accessable: false
        },
        {
          name: '至60周岁',
          value: '60',
          accessable: false
        },
        {
          name: '至65周岁',
          value: '65',
          accessable: false
        },
        {
          name: '至70周岁',
          value: '70',
          accessable: true
        }
      ]
    }
    return insurancePeriods.map((ele) => {
      ele.accessable = true
      return ele
    })
  },

  /**
   * 可用的交费方式
   * @param {*} state
   */
  accessablePaymentMethods (state) {
    return methods.map((ele) => {
      ele.accessable = true
      return ele
    })
  },

  /**
   * 保险期间的字面
   * @param {*} state
   */
  insurancePeriodName (state) {
    let period = ''
    for (let i = 0, l = insurancePeriods.length; i < l; i++) {
      if (insurancePeriods[i].value === state.order.insurancePeriod) {
        period = insurancePeriods[i].name
      }
    }
    return period
  },

  /**
   * 交费方式的字面
   * @param {*} state
   */
  paymentMethodName (state) {
    let method = ''
    for (let i = 0, l = methods.length; i < l; i++) {
      if (methods[i].value === state.order.paymentMethod) {
        method = methods[i].name
      }
    }
    return method
  },

  /**
   * 保费
   * 根据投保人身份证计算
   * @param {*} state
   */
  paymentByIDNumber (state) {
    return 1234
  },

  /**
   * 保费
   * 根据投保人出生日期计算
   * @param {*} state
   */
  paymentByBirthday (state) {
    return 1234
  },

  /**
   * 保单倒计时格式转换
   * @param {*} state
   */
  formatCountdownTimer (state) {
    const countdownTimer = state.order.countdownTimer
    let minute = Math.floor(countdownTimer / 60)
    let second = countdownTimer % 60
    if (minute < 10) {
      minute = '0' + minute
    }
    if (second < 10) {
      second = '0' + second
    }
    return {
      minute,
      second
    }
  },

  /**
   * 保障额度的字面
   * @param {*} state
   */
  insuranceAmountName (state) {
    let name = ''
    for (let i = 0, l = amounts.length; i < l; i++) {
      if (amounts[i].value === state.order.insuranceAmount) {
        name = amounts[i].name
        break
      }
    }
    return name
  },

  /**
   * 交费期间的字面
   * @param {*} state
   */
  paymentPeriodName (state) {
    let name = ''
    for (let i = 0, l = periods.length; i < l; i++) {
      if (periods[i].value === state.order.paymentPeriod) {
        name = periods[i].name
        break
      }
    }
    return name
  },

  /**
   * 根据保险人关系计算出生日期的限制范围
   * @param {*} state
   */
  limitDate (state) {
    let d = {
      startDate: '',
      endDate: ''
    }
    const now = new Date()
    const nowYear = now.getFullYear()
    const nowMonth = now.getMonth()
    const nowDate = now.getDate()
    const startDate = new Date(nowYear - 61, nowMonth, nowDate + 1)
    let endDate = new Date(nowYear - 18, nowMonth, nowDate)
    d.startDate = startDate.getFullYear() + '-' + ((startDate.getMonth() + 1) < 10 ? '0' + (startDate.getMonth() + 1) : (startDate.getMonth() + 1)) + '-' + (startDate.getDate() < 10 ? '0' + startDate.getDate() : startDate.getDate())
    d.endDate = endDate.getFullYear() + '-' + ((endDate.getMonth() + 1) < 10 ? '0' + (endDate.getMonth() + 1) : (endDate.getMonth() + 1)) + '-' + (endDate.getDate() < 10 ? '0' + endDate.getDate() : endDate.getDate())
    return d
  },

  /**
   * 可用的候选投保人
   * @param {*} state
   */
  candidateInsureds (state) {
    return candidateInsureds.map((ele) => {
      ele.accessable = true
      return ele
    })
  },

  /**
   * 可用的性别
   * @param {*} state
   */
  sexs (state) {
    return sexs.map((ele) => {
      ele.accessable = true
      return ele
    })
  },

  /**
   * 根据被保人出生日期计算年龄
   * @param {*} state
   */
  ageFromBirthday (state) {
    let age = getAgeFromBirthday(state.insured.birthday)
    return age
  },

  /**
   * 根据被保人身份证计算年龄
   * @param {*} state
   */
  ageFromIDNumber (state) {
    return getAgeAndSexFromID(state.insured.IDNumber).age
  },

  /**
   * 根据被保人身份证计算性别
   * @param {*} state
   */
  sexFromIDNumber (state) {
    return getAgeAndSexFromID(state.insured.IDNumber).sex
  },

  /**
   * 根据保障额度计算保费
   * @param {*} state
   */
  computMeasurePayment (state) {
    if (state.order.measurePayment === null || state.order.measurePayment === false) {
      return null
    }
    return state.order.measurePayment * Number(state.order.insuranceAmount)
  },

  /**
   * 根据保障额度计算正式的保费
   * @param {*} state
   */
  computPaymentByIDNumber (state) {
    if (state.order.paymentByIDNumber === null || state.order.paymentByIDNumber === false) {
      return null
    }
    return state.order.paymentByIDNumber * Number(state.order.insuranceAmount)
  },

  /**
   * 根据银行value计算银行Code
   * @param {*} state
   */
  bankCode (state) {
    if (state.holder.bankName.length === 0) {
      return ''
    }
    return bankCodes[state.holder.bankName[0]]
  },

  /**
   * 选择的优惠券
   * @param {*} state
   */
  selectedTickets (state) {
    const selected = []
    state.activity.tickets.forEach((ele) => {
      if (ele.selected) {
        selected.push(ele)
      }
    })
    return selected
  }
}



// WEBPACK FOOTER //
// ./src/store/getters.js